let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lV6M9")).then(() => parcelRequire('cYx2E'));